import { ATSStateJobBoardFiltersDataTestIds } from 'data-testids/ATS';

export const StateJobBoardLocationFilterDataTestIds = {
  locationInput: ATSStateJobBoardFiltersDataTestIds.LOCATION_FILTER,
  distanceFilter: ATSStateJobBoardFiltersDataTestIds.DISTANCE_FILTER,
  locationDistanceKeywordSubmitButton:
    ATSStateJobBoardFiltersDataTestIds.LOCATION_DISTANCE_KEYWORD_SUBMIT_BUTTON,
};
